import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';
import { ApartmentDTO, EntrancePlantDetailDTO } from 'client-generator/generated-clients/plants';
import { PropType } from 'vue';
import DialogEditBadge from './DialogEditBadge/DialogEditBadge.vue';

@Options({
  name: 'BadgesSection',
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['onBadgesChange'],
  components: { DialogEditBadge },
})
export default class BadgesSection extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  apartment!: ApartmentDTO;
  badges: string[] = [];
  isVisibleDialogEditBadge = false;

  mounted(): void {
    this.badges = this.apartment.badgeList ?? [];
  }

  onSaveBadge(badgeCode: string) {
    if (!this.badges?.includes(badgeCode)) {
      this.badges?.push(badgeCode);
      this.$emit('onBadgesChange', this.badges);
      this.isVisibleDialogEditBadge = false;
      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResourceEP.BadgeAdded'),
        closable: false,
        life: 3000,
      });
    }
    else {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.alreadyExisting'),
        closable: false,
        life: 3000,
      });
    }
  }

  onDeleteBadge(badgeCode: string) {
    this.badges = this.badges.filter((b) => b !== badgeCode);
    this.$emit('onBadgesChange', this.badges);
    this.$toast.add({
      severity: 'success',
      summary: this.$t('AppResourceEP.BadgeRemoved'),
      closable: false,
      life: 3000,
    });
  }

  onShowAddBadgeDialog() {
    this.isVisibleDialogEditBadge = true;
  }
}
